import {Component, OnInit} from '@angular/core';
import {LanguageService} from '../shared/language.service';
import {AmplifyService} from 'aws-amplify-angular';
import {NewsItem} from './news.item';
import {DomSanitizer} from '@angular/platform-browser';

const customData_eng = require('../data/news.eng.json');
const customData_ger = require('../data/news.ger.json');
const customData_nl = require('../data/news.nl.json');

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {

  private languageService: LanguageService;
  private amplifyService: AmplifyService;
  newsItems: NewsItem[] = [];
  private documents: Map<String, NewsItem[]>;

  constructor(public sanitizer: DomSanitizer, languageService: LanguageService, amplifyService: AmplifyService) {
    this.languageService = languageService;
    this.amplifyService = amplifyService;
    this.sanitizer = sanitizer;
    this.documents = new Map<String, NewsItem[]>([['eng', customData_eng.news], ['ger', customData_ger.news], ['nl', customData_nl.news]]);
  }

  forLanguage(language: String): boolean {
    return this.languageService.isLanguage(language);
  }

  ngOnInit() {
    this.loadNewsItems();
    this.languageService.languageChanged.subscribe(l => this.loadNewsItems());
  }

  onrefresh() {
    this.loadNewsItems();
  }

  private loadNewsItems() {
    const language = this.languageService.getLanguage();
    console.log('news for ' + language + ' : ' + this.documents.get(language));
    this.newsItems = this.documents.get(language);
  }

}

export class News {
  title: String;
  content: String;
}
